/**
 * Central configuration for all API endpoints
 * This drives the dynamic generation of RTK Query endpoints
 * Pattern matches restohub-frontend admin
 */

export interface ApiEndpoint {
  name: string
  path: string
  actions: ('LIST' | 'GET' | 'POST' | 'PATCH' | 'DELETE' | 'PUT')[]
  tags?: string[]
}

// Import endpoint groups from separate files
import { publicMenuEndpoints } from './endpoints/public-menu'
import { orderEndpoints } from './endpoints/orders'
import { paymentEndpoints } from './endpoints/payments'
import { couponEndpoints } from './endpoints/coupons'
import { notificationEndpoints } from './endpoints/notifications'

// Combine all endpoint groups into a single array
export const apiEndpoints: ApiEndpoint[] = [
  ...publicMenuEndpoints,
  ...orderEndpoints,
  ...paymentEndpoints,
  ...couponEndpoints,
  ...notificationEndpoints,
]

// Derive cache tags from endpoints (explicit tags + auto-generated entity name tags)
export const CACHE_TAGS = [
  ...new Set(apiEndpoints.flatMap((e) => [
    e.name.charAt(0).toUpperCase() + e.name.slice(1),
    ...(e.tags || []),
  ])),
] as const

export type CacheTag = (typeof CACHE_TAGS)[number]
